import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import '../App.css';

const Loader = ({ onComplete, endpoint }) => {
  const [range, setRange] = useState({ start: 0, stop: 10 });
  const [statusText, setStatusText] = useState('');
  const [isCompleted, setIsCompleted] = useState(false);

  const lastRange = useRef({ start: null, stop: null }); 

  const sendBatch = async (start, stop) => {
    try {
      
      if (lastRange.current.start === start && lastRange.current.stop === stop) return;

      lastRange.current = { start, stop };

      const response = await axios.post(
        `${endpoint}?range_s=${start}&range_e=${stop}`
      );
      const resData = response.data;

      console.log("res data", resData);

      if (resData.data.completed) {
        setStatusText(`All ${resData.data.stop_range} messages sent!`);
        setIsCompleted(true);
        onComplete();
      } else {
        setStatusText(`${resData.data.sent_count} Messages Sent!`);
        setTimeout(() => {
          setRange({
            start: resData.data.next_range_s,
            stop: resData.data.next_range_e,
          });
        }, 1000);
      }
    } catch (error) {
      console.error('Error sending messages:', error);
      setStatusText('Error occurred!');
      setIsCompleted(true);
      onComplete();
    }
  };

  useEffect(() => {
    if (!isCompleted) {
      sendBatch(range.start, range.stop);
    }
  }, [range, isCompleted]);

  return (
    <div className="loader-div">
      <span className="loader">
        <span></span>
        <span></span>
      </span>
      <p style={{ color: '#fff', marginTop: '1rem' }}>{statusText}</p>
    </div>
  );
};

export default Loader;
